// Newbie Topic 4 — Trend. Very simple English. Scenes in src/ebook/scenes/amateur.jsx
export default {
  title: 'Trend',
  summary: 'Is the price climbing, falling, or going sideways?',
  subtopics: [
    {
      title: 'Uptrend', scene: 'uptrend',
      cards: [
        { icon: '🪜', title: 'Like climbing stairs', body: 'In an uptrend, price goes up, rests a little, then goes up again. It looks like a staircase going up.' },
        { icon: '⛰️', title: 'Higher Highs (HH)', body: 'Each top is higher than the top before. These are called Higher Highs.' },
        { icon: '🏕️', title: 'Higher Lows (HL)', body: 'Each dip (rest stop) is also higher than the dip before. These are called Higher Lows.' },
        { icon: '🟢', title: 'What to do', body: 'In an uptrend, look for chances to BUY when the price takes a small rest (a Higher Low). Go with the flow, not against it.' },
      ],
    },
    {
      title: 'Downtrend', scene: 'downtrend',
      cards: [
        { icon: '🛝', title: 'Like going down stairs', body: 'In a downtrend, price falls, bounces up a little, then falls again. It looks like stairs going down.' },
        { icon: '🔻', title: 'Lower Highs (LH)', body: 'Each bounce up stops lower than the bounce before. These are Lower Highs.' },
        { icon: '🕳️', title: 'Lower Lows (LL)', body: 'Each bottom is lower than the bottom before. These are Lower Lows.' },
        { icon: '🔴', title: 'What to do', body: 'In a downtrend, look for chances to SELL when the price bounces up a little (a Lower High). Don\'t try to catch a falling knife!' },
      ],
    },
    {
      title: 'Sideways', scene: 'sideways',
      cards: [
        { icon: '🏓', title: 'Like ping-pong', body: 'Sometimes price goes left and right, not up or down. It bounces between a floor and a ceiling, like a ping-pong ball.' },
        { icon: '📦', title: 'A box (range)', body: 'Traders call this a range. The tops are about the same height, and the bottoms are about the same height.' },
        { icon: '⚖️', title: 'Nobody is winning', body: 'Buyers and sellers are equally strong. So the price waits and moves side to side.' },
        { icon: '⏳', title: 'Be patient', body: 'In a range, some traders buy near the floor and sell near the ceiling. Many simply wait until price breaks out of the box.' },
      ],
    },
  ],
};
